<template>
    <div :class="{topActive : activeShow}">
        <!--头部-->
        <div class="container">
            <video preload="auto" muted="" loop="" autoplay="" id="video">
                <source type="video/mp4" src="/xyd/img/yybj.mp4">
            </video>

            <div class="topMain">
                <div class="navListBox">
                    <div class="logoBox">
                        <p class="logo">{{ systemName.value }}</p>
                        <p class="name">全国中小企业融资综合信用服务平台&nbsp;&nbsp;岳阳站</p>
                    </div>

                    <div class="menuBox">
                        <router-link :to="{name: 'index'}"><span class="cs2_nemu1">首页</span></router-link>
                        <router-link :to="{name: 'financePro'}"><span class="cs2_nemu2">金融超市</span>
                        </router-link>
                        <router-link :to="{name: 'organization'}"><span class="cs2_nemu2">金融机构</span>
                        </router-link>
                        <router-link :to="{name: 'news'}"><span class="cs2_nemu2">资讯动态</span>
                        </router-link>
<!--                        <router-link :to="{name: 'fxts'}"><span class="cs2_nemu2">风险提示</span>
                        </router-link>-->
                        <router-link :to="{name: 'creditInquiry'}"><span class="cs2_nemu2">信用查询</span>
                        </router-link>
                      <a-popover placement="bottomLeft">
                        <template slot="content">
                          <div style="width: 80px;height: 30px;border-bottom: #cccccc 1px dashed" v-for="item in characteristicArea">
                            <router-link tag="a" target="_blank" :to="{name:'financePro',query:{specialArea:item.param}}">
                              <span style="color: #333333;line-height: 30px">{{item.desc}}</span>
                            </router-link>
                          </div>
                        </template>
                        <span class="cs2_nemu2" >特色专区</span>
                      </a-popover>
                      <router-link :to="{name: 'questions'}"><span class="cs2_nemu2">常见问题</span>
                      </router-link>
                        <router-link :to="{name: 'introduce'}"><span class="cs2_nemu2">平台介绍</span>
                        </router-link>
                    </div>

                    <div class="cs1_12_2" v-if="!this.$store.state.account.accountNonExpired">
                        <span @mouseover="loginOver()"  @mouseleave="loginLeave()">登录</span>
                        <span>&nbsp;&nbsp;|&nbsp;&nbsp;
                          <a target="_blank" href="https://auth.zwfw.hunan.gov.cn/oauth2/register/register.html">注册</a>
<!--                          <router-link :to="{path: 'sm_registe2'}" target="_blank">注册</router-link>-->
                        </span>
                        <div class="menu_sub" v-show="menuShow" @mouseover="loginOver()" @mouseleave="loginLeave()">
                            <i class="uparrow"></i>
                            <a class="nav-right-item" href="javascript:;" @click="info">中小企业登录</a>
<!--                            <p><router-link :to="{path: 'loginCompany'}" target="_blank">中小企业登录</router-link></p>-->
                            <router-link :to="{path: 'loginFinance'}" target="_blank">金融机构登录</router-link>
                            <router-link :to="{name: 'Login'}" target="_blank">政府部门登录</router-link>
                        </div>
                        <!--                <a target="_blank" href="https://auth.zwfw.hunan.gov.cn/oauth2/register/register.html">注册</a>-->
                        <!--                <a class="nav-right-item" href="javascript:;" @click="info">中小企业</a>-->
                        <!--                |-->
                        <!--                <router-link :to="{path: 'loginFinance'}" target="_blank">金融机构</router-link>-->
                        <!--                |-->
                        <!--                <router-link :to="{name: 'Login'}" target="_blank">政府部门</router-link>-->
                    </div>
                    <div class="cs1_12_3" v-if="this.$store.state.account.accountNonExpired">
                        你好，
                        {{ this.$store.state.account.name }}
                        &nbsp;|&nbsp;
                        <a class="nav-right-item" href="javascript:;" @click="goto">
                            工作台
                        </a>
                        &nbsp;|&nbsp;
                        <a class="nav-right-item" href="javascript:;" @click="out">
                            退出
                        </a>
                    </div>

                    <div style="clear: both;"></div>
                </div>
            </div>

            <!--<div class="slogan">金融服务实体 信用创造价值</div>-->

            <div class="navList">
                <div class="navBox">
                    <router-link :to="{name: 'financePro'}">
                        <img src="../assets/img/dk.svg" class="navIco"/>
                        <span class="navTitle">我要贷款</span>
                    </router-link>
                </div>
                <div class="navBox">
                    <router-link to="/financePro?type=1">
                        <img src="../assets/img/db.svg" class="navIco"/>
                        <span class="navTitle">我要担保</span>
                    </router-link>
                </div>
                <div class="navBox">
                    <router-link to="/zdcpShop">
                        <img src="../assets/img/zd.svg" class="navIco"/>
                        <span class="navTitle">我要转贷</span>
                    </router-link>
                </div>
                <div class="navBox" @click="bulding">
                    <router-link to="">
                        <img src="../assets/img/zl.svg" class="navIco"/>
                        <span class="navTitle">我要租赁</span>
                    </router-link>
                </div>
                <div class="navBox">
                    <router-link to="/financePro?type=2">
                        <img src="../assets/img/bx.svg" class="navIco"/>
                        <span class="navTitle">我要保险</span>
                    </router-link>
                </div>
            </div>

            <div class="totalListBox">
                <div class="totalList">
                    <div class="totalbox">
                        <router-link :to="{name: 'organization'}">
                            <span class="dd1_12_5_wz1">{{ overview.yxdw }}</span>
                            <span class="dd1_12_5_wz2">家</span><br>
                            <span class="dd1_12_5_wz2">金融机构</span>
                        </router-link>
                    </div>
                    <div class="totalbox">
                        <router-link :to="{name: 'financePro'}">
                            <span class="dd1_12_5_wz1">{{ overview.finpro }}</span>
                            <span class="dd1_12_5_wz2">个</span><br>
                            <span class="dd1_12_5_wz2">金融产品</span>
                        </router-link>
                    </div>
                    <div class="totalbox">
                        <span class="dd1_12_5_wz1">{{ overview.company }}</span>
                        <span class="dd1_12_5_wz2">个</span><br>
                        <span class="dd1_12_5_wz2">注册用户</span>
                    </div>
                    <div class="totalbox">
                        <span class="dd1_12_5_wz1">{{ overview.loan }}</span>
                        <span class="dd1_12_5_wz2">笔</span><br>
                        <span class="dd1_12_5_wz2">授信笔数</span>
                    </div>
                    <div class="totalbox">
                        <span class="dd1_12_5_wz1">{{ (overview.loanAmout / 100000000).toFixed(2) }}</span>
                        <span class="dd1_12_5_wz2">亿</span><br>
                        <span class="dd1_12_5_wz2">授信金额</span>
                    </div>
                    <div class="totalbox">
                        <span class="dd1_12_5_wz1">{{ overview.communication }}</span>
                        <span class="dd1_12_5_wz2">笔</span><br>
                        <span class="dd1_12_5_wz2">正在对接</span>
                    </div>
                </div>
            </div>
        </div>

        <!--智能客服-->
<!--        <CustomerService/>-->

        <!--在线留言-->
        <OnlineMsg/>

        <!--移动端二维码-->
<!--        <div class="qrCode" v-show="showQrCode">
            <div class="iconCancel">
                <a-icon @click="showQrCode = false" type="close-circle"
                        :style="{ fontSize: '16px', color: '#08c' }"/>
            </div>
            <img src="../assets/img/mobileQRCode.png"/>
        </div>-->

        <!--我要贷款-->
        <div class="loanBox">
            <div class="loanMain">
                <div class="loanTitle"><img src="../assets/img/js.png"/>我要贷款</div>
                <div class="loanList">
                    <p>贷款期限</p>
                    <a-select v-model="termvalue" style="width: 140px;margin-left: 8px;" placeholder="选择贷款期限">
                        <a-select-option value="">
                            选择贷款期限
                        </a-select-option>
                        <a-select-option :value="item" v-for="item in term" :key="item.id">
                            {{ item }}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="loanList">
                    <p>贷款额度</p>
                    <a-select v-model="amountvalue" style="width: 140px;margin-left: 8px;" placeholder="选择贷款额度">
                        <a-select-option value="">
                            选择贷款额度
                        </a-select-option>
                        <a-select-option :value="item" v-for="item in amount" :key="item.id">
                            {{ item }}
                        </a-select-option>
                    </a-select>
                </div>
                <div class="loanList">
                    <p>利率</p>
                    <a-input
                            v-model="loanVal"
                            type="number"
                            style="width: 170px;display: flex;margin: -65px 0 0 45px;"
                            addon-after="%" placeholder="填写贷款利率"/>
<!--                    <a-select  style="width: 140px;margin-left: 8px;" placeholder="选择贷款利率">-->
<!--                        <a-select-option value="1">-->
<!--                            选择贷款利率-->
<!--                        </a-select-option>-->
<!--                    </a-select>-->
                </div>
                <div class="loanList">
                    <p>担保方式</p>
                    <a-select v-model="guaranteeVal"  style="width: 140px;margin-left: 8px;" placeholder="选择担保方式">
                        <a-select-option v-for="item in guarantee" :value="item.value" :key="item.id">
                            {{item.key}}
                        </a-select-option>
                    </a-select>
                </div>
                <div>
                    <a-button type="primary" @click="searchProduct">
                        查询产品
                    </a-button>
                </div>
            </div>
        </div>

        <!--热门产品-->
        <div class="dd2">
            <div class="dd2_123">
                <img src="../assets/img/hz4.png">
            </div>
            <div class="dd2_12">
                <div class="dd2_12_1" v-for="(item,index) in producesList">
                    <div class="dd2_12_1_dw1">
                        <div :class="'topcss'+index">{{ item.productName }}</div>
                    </div>
                    <div class="dd2_12_1_dw2">
                        <div class="dd2_12_1_dw6">
                            <span class="dd2_12_5_wz1">{{ item.loanMin }}-{{ item.loanMax }}万</span><br><span
                                class="dd2_12_5_wz3">额度范围</span>
                        </div>
                        <div class="dd2_12_1_dw6" style=" width:34%;">
                            <span class="dd2_12_5_wz2" v-if="item.rateMin==0&&item.rateMax==0">面议</span>
                            <span class="dd2_12_5_wz2" v-else>{{ parseFloat(item.rateMin).toFixed(2) }}-{{ parseFloat(item.rateMax).toFixed(2) }}%</span>
                            <br><span class="dd2_12_5_wz3">年利率（单利）</span>
                        </div>
                        <div class="dd2_12_1_dw6">
                            <span class="dd2_12_5_wz2">{{ item.loanDeadlineMin }}-{{ item.loanDeadlineMax }}个月</span><br><span
                                class="dd2_12_5_wz3">期限</span>
                        </div>
                    </div>
                    <div class="dd2_12_1_dw3">
                        <img :src="downPath+item.logo" height="30px">
                    </div>
                    <div class="dd2_12_1_dw4" :class="'grad'+index">
                        {{ item.introduction }}
                    </div>
                    <!--<div class="dd2_12_1_dw5">
                        <img src="../assets/img/hz20.png">
                    </div>-->
                </div>
            </div>
            <div class="dd2_12a">
                <router-link :to="{name: 'financePro'}">查看更多<img src="../assets/img/gd.png"/></router-link>
            </div>
        </div>

        <!--申请流程-->
        <div class="processBox">
            <div class="dd2_123">
                <img src="../assets/img/sqlc.png">
            </div>
            <div style="height: 130px;">
                <a-steps style="width: 1200px;margin:30px auto;" labelPlacement="vertical" id="process">
                    <a-step status="finish" title="注册用户">
                        <a-icon slot="icon" type="user-add" :style="{ fontSize: '50px',color: '#ffffff'}"/>
                    </a-step>
                    <a-step status="finish" title="提交申请">
                        <a-icon slot="icon" type="form" :style="{ fontSize: '50px',color: '#ffffff'}"/>
                    </a-step>
                    <a-step status="finish" title="审核通过">
                        <a-icon slot="icon" type="file-protect" :style="{ fontSize: '50px',color: '#ffffff'}"/>
                    </a-step>
                    <a-step status="finish" title="获取额度">
                        <a-icon slot="icon" type="transaction" :style="{ fontSize: '50px',color: '#ffffff'}"/>
                    </a-step>
                </a-steps>
            </div>
        </div>

        <!--资讯动态-->
        <div class="dd3">
            <div class="dd3_12">
                <div class="dd2_123">
                    <img src="../assets/img/zxdt.png">
                </div>

                <div class="newsSelect">
                    <p :class="{active:newsType == 0}" @click="switchNews(0)">新闻动态></p>
<!--                    <p :class="{active:newsType == 1}" @click="switchNews(1)">政策资讯></p>
                    <p :class="{active:newsType == 2}" @click="switchNews(2)">金融知识></p>-->
                </div>

                <div class="dd3_6" v-show="show">
                    <div v-for="item in newsList" @click="openDetail(item.id)" :key="item.id" class="newslistBox">
                        <div class="dd3_t2" style="font-weight:600;">
                            {{ item.title.length > 36 ? item.title.substring(0, 36) + '...' : item.title }}
                        </div>
                        <div class="dd3_t3">
                            {{ item.createTime.length > 19 ? item.createTime.substring(0, 19) : item.createTime }}
                        </div>
                        <div class="dd3_t4">
                            {{
                            item.content.replace(/<[^>]+>/g, "").length > 70 ? getContent(item.content).replace(/<[^>]+>/g,
                            "").substring(0, 70) + '...' : getContent(item.content).replace(/<[^>]+>/g, "")
                            }}
                        </div>
                    </div>
                    <div class="dd3_t5">
                        <router-link :to="{name: 'news'}">查看更多<img src="../assets/img/gd.png"/></router-link>
                    </div>
                </div>
                <div class="dd3_6" v-show="show2">
                    <div v-for="item in policiesList" class="newslistBox">
                        <div class="dd3_t2" style="font-weight:600;" @click="openDetail(item.id)">
                            {{ item.title.length > 36 ? item.title.substring(0, 36) + '...' : item.title }}
                        </div>
                        <div class="dd3_t3">
                            {{ item.createTime.length > 19 ? item.createTime.substring(0, 19) : item.createTime }}
                        </div>
                        <div class="dd3_t4">
                            {{
                            item.content.replace(/<[^>]+>/g, "").length > 70 ? getContent(item.content).replace(/<[^>]+>/g,
                            "").substring(0, 70) + '...' : getContent(item.content).replace(/<[^>]+>/g, "")
                            }}
                        </div>
                    </div>
                    <div class="dd3_t5">
                        <router-link :to="{name: 'news'}">查看更多<img src="../assets/img/gd.png"/></router-link>
                    </div>
                </div>
                <div class="dd3_6" v-show="showKnowledge">
                    <div v-for="item in knowledgeList" class="newslistBox">
                        <div class="dd3_t2" style="font-weight:600;" @click="openDetail(item.id)">
                            {{ item.title.length > 36 ? item.title.substring(0, 36) + '...' : item.title }}
                        </div>
                        <div class="dd3_t3">
                            {{ item.createTime.length > 19 ? item.createTime.substring(0, 19) : item.createTime }}
                        </div>
                        <div class="dd3_t4">
                            {{
                            item.content.replace(/<[^>]+>/g, "").length > 70 ? getContent(item.content).replace(/<[^>]+>/g,
                            "").substring(0, 70) + '...' : getContent(item.content).replace(/<[^>]+>/g, "")
                            }}
                        </div>
                    </div>
                    <div class="dd3_t5">
                        <router-link :to="{name: 'news'}">查看更多<img src="../assets/img/gd.png"/></router-link>
                    </div>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <div class="dd2">
            <img src="../assets/img/albj.png" class="albj"/>
            <div class="case">
                <!--成功案例-->
                <div class="caseBox">
                    <p class="caseTitle">
                        <span class="caseIco"></span>成功案例
                    </p>
                    <div class="alList" v-for="(item,index) in successList" :key="item.id">
                        <div class="body">
                            <h2>{{item.companyName}}</h2>
                            <p class="alMes">
                                <span>合作银行</span>
                                <span>{{item.logindept}}</span>
                            </p>
                            <p class="alMes">
                                <span>融资金额</span>
                                <span class="alNum">{{(item.loanAmout/10000).toFixed()}}万</span>
                            </p>
                        </div>
                        <div :class="'aljg cg'+(parseInt(index)+1)">对接成功</div>
                    </div>
                </div>

                <!--需求发布-->
                <div class="needsBox">
                    <p class="caseTitle"><span class="caseIco"></span>需求发布</p>
                    <div id="silderBox">
                        <div  class="silder-wrapper"
                              :style="{
                     top: (needslist.length > 5 ? -listIndex * 95 : 0) + 'px',
                     transition: animated ? '1s' : 'none'
                     }"
                        >
                            <div class="needsList">
                                <ul v-for="(item, index) in demandList" :key="index">
                                    <li class="needsTime"><span>{{ item.day }}</span><span>{{ item.month }}</span></li>
                                    <li class="needsMes">{{ item.news }}<span style="float: right">需求<span style="color: red">{{ item.money }}</span>万元</span></li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!--排行榜-->
        <div class="dd6">
            <div class="case">
                <!--金融机构累计授信-->
                <div class="listBox">
                    <p class="caseTitle">
                        <span class="caseIco"></span>金融机构累计授信排行榜
                    </p>
                    <div class="unit">单位：万元</div>
                    <!--            <div v-for="item in bankRank" style="width: 100%;line-height: 30px">{{item.logindept}},{{item.sum}}</div>-->
                    <div id="bankChart" style="width: 100%;height: 200px"></div>
                </div>

                <!--产品累计授信排行榜-->
                <div class="listBox">
                    <p class="caseTitle"><span class="caseIco"></span>产品累计授信排行榜</p>
                    <div class="unit">单位：万元</div>
                    <!--            <div v-for="item in productRank" style="width: 100%;line-height: 30px">{{item.product_name}},{{item.sum}}</div>-->
                    <div id="productChart" style="width: 100%;height: 200px"></div>
                </div>

            </div>
        </div>

        <!--合作伙伴-->
        <div class="dd4">
            <div class="dd4_t">
                <img src="../assets/img/hz7.png">
            </div>

            <div class="linkBox">
                <p class="linkBt"><span class="caseIco"></span>信用岳阳</p>
                <div class="linkList">
                    <div class="linkNr"><a href="http://credit.yueyang.gov.cn" target="_blank"><img src="../assets/img/xyyy.png"/></a></div>
                </div>
                <p class="linkBt"><span class="caseIco"></span>金融机构</p>
                <div class="linkList">
                    <div class="linkNr" v-for="item in organizationList"><img :src="downPath+item.logo" style="max-height:70px;max-width:190px"/></div>

                </div>
            </div>

            <a-row class="project-case">
                <div class="content">
                    <div
                            class="content-list"
                            ref="contentList"
                            @mousedown.prevent="contentListMouseDown"
                    >
                    </div>
                </div>
            </a-row>
        </div>

        <!--版权信息-->
        <div class="dd5">
            <div class="dd5_copyright" style="position: relative">
              <a href="https://bszs.conac.cn/sitename?method=show&id=54414D6082843FDFE053022819ACA6F1" target="_blank"><img src="../assets/img/dzjg.png" style="position: absolute;
    bottom: -15px;
    left: calc(50% - 530px)"/></a>
              主办单位：{{ footOrganizer.value }}　　　技术支持：{{ footSupport.value }}<br/>
              　　　联系电话：0730-8880641　　　网站标识码: 4306000069　　　<a href="http://beian.miit.gov.cn/" target="_blank" style="color: #FFFFFF">湘ICP备09024640号</a>　　　<a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" style="color: #FFFFFF;margin-left: 40px">湘公网安备: 43060202000064号</a><br/>
<!--                技术咨询服务电话： 0731-85240266 150-7333-7666（庞先生）-->
              <a href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=4306000069&url=http%3A%2F%2Fcredit.yueyang.gov.cn%2Findex.html" target="_blank"><img src="../assets/img/zfjc.png" style="position: absolute;
    bottom: 0px;
    left: calc(50% + 450px)"/></a>
            </div>
            </div>

    </div>
</template>

<script>
    import {
        getHotPros,
        getTotol,
        getLast50,
        getSuccessfulCases,//获取成功案例
        getDemandRelease, //获取需求发布前50条
        indexRank,//授信排行榜
        addOnlineMessage,//添加在线留言
    } from '@/api/finance/finance.js'
    import {getTypes} from '@/api/finance/finance'
    import {findByCount} from "@/api/operate/article"
    import {loginOut,hnzw} from "@/api/user";
    import {findYxdwList} from "@/api/operate/employer";
    import {mapState, mapGetters} from "vuex";
    import {Icon} from 'ant-design-vue';
    import {StarOutlined, StarFilled, StarTwoTone} from '@ant-design/icons';
    import CustomerService from "@/components/customerService/customerService";
    import OnlineMsg from "@/components/onlineMessage/OnlineMessage";
    import moment from 'moment';

    moment.locale('zh-cn');

    export default {
        components: {
            CustomerService,
            OnlineMsg
        },
        computed: {
            ...mapState(["downPath", "menuSourceList"]),
            ...mapGetters(["systemName", "footOrganizer", "footSupport", "storeAccount"]),
        },
        destroyed() {
            window.removeEventListener('scroll',this.onScroll);
        },
        mounted() {
            window.addEventListener('scroll',this.onScroll);
            this.initSuccessfulCases();
            // this.initdemandList();
           // 定时器滚动
            this.$refs.contentList.addEventListener("mouseenter", () => {
                this.stopFlag = true;
            });
            this.$refs.contentList.addEventListener("mouseleave", () => {
                this.stopFlag = false;
                // 在mouseleave时也移除move和up事件
                this.mouseUp()
            });
            this.contentListWidth = parseInt(getComputedStyle(this.$refs.contentList).width);
            this.count = parseInt(getComputedStyle(this.$refs.contentList).width);
            this.timerId = setInterval(() => {
                if (this.stopFlag) return;
                this.count++;
                if (
                    this.count == this.contentListWidth * this.listLength
                ) {
                    this.count = this.contentListWidth
                }
                this.$refs.contentList.style.transform = `translateX(-${this.count}px)`;
            }, 15);

            // this.silder();
            this.initdemandList();
            //初始化排行榜
          indexRank()
              .then(res => {
                this.bankRank = res.data.data.banklist;
                this.productRank = res.data.data.productlist;
                this.initProductChart();
                this.initBankChart();
              })
        },
        data() {
            return {
                producesList: [],
                newsList: [],
                successList: [],
                demandList: [],
                policiesList: [],
                knowledgeList: [],
                bankRank:[],
                productRank:[],
              characteristicArea: [],
                jrjg: 0,
                jrcp: 0,
                zcqy: 0,
                yxje: 0,
                ljsx: 0,
                sxje: 0,
                zzdj: 0,
                rzlist: [],
                organizationList: [],
                rzindex: 0,
                loanVal: null,
                animated: true,
                showQrCode: true,
                overview: {
                    communication: 0,
                    comAmount: 0,
                    loan: 0,
                    loanAmout: 0,
                    yxdw: 0,
                    finpro: 0,
                    company: 0,
                    loanSum: 0
                },
                term: ["不限", "12个月（含）以下", "12~36个月（含）以下", "36~60个月（含）以下", "60个月以上"],
                amount: ["不限", "30万以下", "30~100万", "100~300万", "300~500万", "500万以上"],
                amountvalue: "",
                termvalue: "",
                timerId: "",
                count: 0,
                stopFlag: false,
                mousePosition_down: "",//鼠标点击时的位置
                contentListWidth: '',//list的宽度
                listLength: 3,//要显示的图片占据的list
                moveFlag: false,//鼠标拖动时，阻止路由跳转
                newsType: 0,
                show: true,
                show2: false,
                showKnowledge: false,
                menuShow: false,
                activeShow: false,
                guaranteeVal: "",
                guarantee: [
                    {
                        key :"请选择担保方式",
                        value :"",
                    },
                    {
                        key :"不限",
                        value :"不限",
                    },
                    {
                        key :"抵押",
                        value :"抵押",
                    },
                    {
                        key :"质押",
                        value :"质押",
                    },
                    {
                        key :"信保基金",
                        value :"信保基金",
                    },
                    {
                        key :"一般保证",
                        value :"一般保证",
                    },
                    {
                        key :"信用",
                        value :"信用",
                    },
                    {
                        key :"保证",
                        value :"保证",
                    },
                    {
                        key :"连带责任保证",
                        value :"连带责任保证",
                    },

                ],
                listIndex: 0,
                animated: true,
                needslist:[
                    {"day":"29","month":"2021/10","news":"全成县***成功发布债券融资需求资需求资需求10.00万元"},
                    {"day":"28","month":"2021/10","news":"全成县***成功发布债券融资需求资需求资需求10.00万元"},
                    {"day":"27","month":"2021/10","news":"全成县***成功发布债券融资需求资需求资需求10.00万元"},
                    {"day":"26","month":"2021/10","news":"全成县***成功发布债券融资需求资需求资需求10.00万元"},
                    {"day":"25","month":"2021/10","news":"全成县***成功发布债券融资需求资需求资需求10.00万元"},
                    {"day":"24","month":"2021/10","news":"全成县***成功发布债券融资需求资需求资需求10.00万元"}
                ],
            };
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.initConfig();
                vm.rzsilder();
                vm.findYxdwList();
              vm.initParams();
            })
        },
        beforeDestroy() {
            clearInterval(this.timerId)
        },
        methods: {
          bulding() {
            this.$message.warning("正在建设中，暂未开放");
          },
            // 页面滚动
            onScroll(){
                this.activeShow = true;
                let winHeight = document.documentElement.scrollTop;
                if( winHeight == 0){
                    this.activeShow = false;
                }
            },
            // 资讯动态切换
            switchNews(newsType) {
                this.newsType = newsType;
                this.show = false;
                this.show2 = false;
                this.showKnowledge = false;
                // this.show = !this.show;
                if(newsType == 0){
                    this.show = true
                }else if(newsType == 1){
                    this.show2 = true;
                }else if(newsType == 2){
                    this.showKnowledge = true;
                }
            },
            // 登录切换事件
            loginOver(){
                this.menuShow = true;
            },
            loginLeave(){
                this.menuShow = false;
            },
            // 页面滚动事件
            scroll(){
                console.log('页面滚动')
            },

          getContent(content) {
            let arrEntities = {
              lt: "<",
              gt: ">",
              nbsp: " ",
              amp: "&",
              quot: '"'
            };
            return content
                .replace(/<[^>]+>/g, "")
                .replace(
                    /&(lt|gt|nbsp|amp|quot);/gi,
                    (all, t) => arrEntities[t]
                ); //去掉所有的html标记
          },

            initConfig() {
                //this.rzlist = rzlist;

                getTotol()
                    .then(res => {
                        this.overview = res.data.data.map;

                    })
                /*getLast50()
                    .then(res => {
                        this.rzlist = res.data.data.list;

                    })*/

                getHotPros()
                    .then(res => {
                        this.$ajaxAfter(res).then(() => {
                            this.producesList = res.data.data.producesList;
                        })
                    }).catch(() => {
                    this.$message.error("服务器出错！请稍后再试!");
                });

                findByCount(2, 0)
                    .then(res => {
                        this.$ajaxAfter(res).then(() => {
                            this.newsList = res.data.data.list;
                        })
                    }).catch(() => {
                    this.$message.error("服务器出错！请稍后再试!");
                });
                //
                findByCount(2, 1)
                    .then(res => {
                        this.$ajaxAfter(res).then(() => {
                            this.policiesList = res.data.data.list;
                        })
                    }).catch(() => {
                    this.$message.error("服务器出错！请稍后再试!");
                });
                //金融知识
                findByCount(2, 2)
                    .then(res => {
                        this.$ajaxAfter(res).then(() => {
                            this.knowledgeList = res.data.data.list;
                        })
                    }).catch(() => {
                    this.$message.error("服务器出错！请稍后再试!");
                });
            },
             findYxdwList() {
                 findYxdwList()
                     .then(res => {
                         this.$ajaxAfter(res).then(() => {
                             this.organizationList = res.data.data.list
                         })
                     });
             },
            openDetail(id) {
                let routeUrl = this.$router.resolve({
                    name: "newsDetail",
                    query: {id: id}
                });
                window.open(routeUrl.href, '_blank');
            },
          // 初始化特色专区参数
          initParams(){
            getTypes("003010")
                .then(res => {
                  this.$ajaxAfter(res).then(() => {
                    this.characteristicArea = res.data.data.list;
                    this.$delete(this.characteristicArea,0);
                  });
                })
                .catch(() => {
                  this.$toast.fail("服务器出错！请稍后再试!");
                });
          },
            rzsilder() {
                setInterval(() => {
                    this.animated = true;
                    this.rzindex += 1;
                    if (this.rzindex === 2) {
                        setTimeout(() => {
                            this.animated = false;
                            this.rzlist.push(this.rzlist[0], this.rzlist[1]);
                            this.rzlist.splice(0, 2);
                            this.rzindex = 0;
                        }, 800);
                    }
                }, 2000);
            },
            // contentListMouseDown(e) {
            //     // console.log("down", e.offsetX);
            //     this.mousePosition_down = e.offsetX;
            //     this.$refs.contentList.addEventListener("mousemove", this.mouseMove);
            //     this.$refs.contentList.addEventListener("mouseup", this.mouseUp);
            // },
// 鼠标up时，移除move和up事件
            mouseUp() {
                setTimeout(() => {
                    this.moveFlag = false
                }, 0);
                // console.log("up", e.offsetX);
                this.removeListener()
                // 拖动到列表最前面时
                if (this.count < this.contentListWidth) {

                    this.count = parseInt(this.count) + this.contentListWidth * this.listLength
                    this.$refs.contentList.style.transform = `translateX(-${this.count}px)`;
                }
                // 拖动到列表最后面时
                if (this.count > this.contentListWidth * (this.listLength + 1)) {

                    this.count = parseInt(this.count) - this.listLength * this.contentListWidth
                    this.$refs.contentList.style.transform = `translateX(-${this.count}px)`;
                }
            },
// 鼠标move时，list跟随移动
            mouseMove(e) {
                this.moveFlag = true
                // console.log("move", e.offsetX);
                let mousePosition_move = e.offsetX;
                this.count = parseInt(this.mousePosition_down) - mousePosition_move + parseInt(this.count);
                // console.log(this.count);
                this.$refs.contentList.style.transform = `translateX(-${this.count}px)`;
            },
// 移除contentlist的mousemove 和 mouseup；在鼠标up、鼠标移出此元素、时。
            removeListener() {
                this.$refs.contentList.removeEventListener("mousemove", this.mouseMove);
                this.$refs.contentList.removeEventListener("mouseup", this.mouseUp);
            },
            searchProduct() {
                this.loanVal
                this.guaranteeVal
                this.$router.push({
                    name: 'financePro',
                    query: {amount: this.amountvalue, term: this.termvalue,guarantee: this.guaranteeVal,loan:this.loanVal}
                });
            },
            goto() {
                if (this.menuSourceList[0].childMenuSourceList[0].systemMenu) {
                    this.$router.push({
                        name: this.menuSourceList[0].childMenuSourceList[0].code
                    });
                } else {
                    this.$router.push({
                        path: '/crm/new/page/' + this.menuSourceList[0].childMenuSourceList[0].code,
                        query: {id: this.menuSourceList[0].childMenuSourceList[0].id}
                    });
                }
            },
            out() {
                // if (this.storeAccount.roleId == 1025) {
                //     this.$store.commit("clearAccount");
                //   window.location.href = "https://auth.zwfw.hunan.gov.cn/oauth2/logout?client_id=HH93RKy7RM-Mw4Xfq021rA&response_type=code&redirect_uri=http://jrcs.wangcheng.gov.cn:8090/xydapi/unifyLogin/logout";
                // } else {
                    loginOut().then(res => {
                        this.$ajaxAfter(res).then(() => {
                          if (this.storeAccount.roleId == 1025) {
                            window.location.href ="https://auth.zwfw.hunan.gov.cn/oauth2/logout?client_id=cp4zF99JSqG8YDD1wKjB4A&response_type=code&redirect_uri=http://credit.yueyang.gov.cn/xydapi/unifyLogin/syntony";
                          }else{
                            this.$router.push({
                              name: "index"
                            });
                          }
                          // window.location.href = "https://auth.zwfw.hunan.gov.cn/oauth2/logout?client_id=cp4zF99JSqG8YDD1wKjB4A&response_type=code&redirect_uri=";
                          this.$store.commit("clearAccount");
                        });
                    });
                // }
            },

            info() {

              window.location.href = "http://auth.zwfw.hunan.gov.cn/oauth2/authorize?client_id=cp4zF99JSqG8YDD1wKjB4A&response_type=gov&scope=user.read&redirect_uri=http://credit.yueyang.gov.cn/xydapi/unifyLogin/syntony";
              // this.$router.push({
              //   name: "LoginCompany",
              // });
            },
            //初始化成功案例
            initSuccessfulCases(){
                getSuccessfulCases().then(resp=>{
                    if(resp.data.success == "TRUE"){
                        this.successList = resp.data.data.list;
                    }else {
                        this.$message.error(resp.data.message);
                    }
                }).catch(()=>{
                    this.$message.error("服务器异常，请稍后重新刷新页面！")
                })
            },
            initdemandList(){
                getDemandRelease().then(resp=>{
                    if(resp.data.success == "TRUE"){
                        this.demandList = resp.data.data.list;
                        let list = [];
                        this.demandList.forEach(res=>{
                            // console.log(moment(res.createTime).format("DD"))
                            // let date = moment(res.createTime).days();
                            // console.log("日==>"+date)
                            list.push({
                                day: moment(res.createTime).format("DD"),
                                month:moment(res.createTime).format("YYYY/MM"),
                                news:res.companyName,
                                money: (res.commitAmout/10000).toFixed()
                            })

                        })
                        this.demandList = list;

                        if(this.demandList.length > 5){
                            if (this.silder1Time) {
                                clearTimeout(this.silder1Time);
                            }
                            this.silder1Time = setInterval(() => {
                                this.animated = true;
                                this.listIndex += 1;
                                if (this.listIndex === 2) {
                                    setTimeout(() => {
                                        this.animated = false;
                                        if(this.demandList.length > 5){
                                            this.demandList.push(this.demandList[0], this.demandList[1]);
                                            this.demandList.splice(0, 2);
                                            this.listIndex = 0;
                                        }
                                    }, 800);
                                }
                            }, 3000);
                        }
                    }else {
                        this.$message.error(resp.data.message);
                    }
                }).catch(()=>{
                    this.$message.error("服务器异常，请稍后重新刷新页面！")
                })
            },
            // 列表滚动
            silder() {
                if(this.needslist.length > 5){
                    if (this.silder1Time) {
                        clearTimeout(this.silder1Time);
                    }
                    this.silder1Time = setInterval(() => {
                        this.animated = true;
                        this.listIndex += 1;
                        if (this.listIndex === 2) {
                            setTimeout(() => {
                                this.animated = false;
                                if(this.needslist.length > 5){
                                    this.needslist.push(this.needslist[0], this.needslist[1]);
                                    this.needslist.splice(0, 2);
                                    this.listIndex = 0;
                                }
                            }, 800);
                        }
                    }, 3000);
                }
            },
            inputLoan(val){
                let value = String(val.data);
                let reg = /^\\d+(\\.\\d)?\\d{0,1}%$/;
                if (reg.test(value)) {
                    this.loanVal = value;
                }
            },
          initProductChart(){
            let lable=[];
            let data=[];
            this.productRank.forEach((it, index) => {
              lable[this.productRank.length-1-index] = it.product_name;
              data[this.productRank.length-1-index] = it.sum;
            });
            let productChart=this.$echarts.init(document.getElementById('productChart'));

            let colorList=['#63bcfe','#63bcfe','#FFD14C','#fe9312','#FF5410'];

            let option = {
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                }
              },
              legend: {show:false},
              grid: {
                top:'0%',
                left: '0%',
                right: '0%',
                bottom: '0%',
                containLabel: true
              },
              xAxis: {
                show:false
              },
              yAxis: {
                type: 'category',
                axisLine:{
                  show:false
                },
                axisTick:{
                  show:false
                },
                axisLabel:{
                  formatter:function (value, index) {
                    if(value.length>6){
                      return value.substring(0,5) + '…';
                    }else{
                      return value;
                    }
                  }
                },
                data: lable
              },
              series: [
                {
                  name: '授信金额',
                  type: 'bar',
                  label: {
                    show: true,
                    position: 'right'
                  },
                    itemStyle: {
                        normal: {
                            barBorderRadius: 50,
                            color: (params) => {
                                return colorList[params.dataIndex]
                            }
                        },
                    },
                    barWidth: 15,
                  data: data
                }
              ]
            };
            productChart.setOption(option)
          },
          initBankChart(){
            let lable=[];
            let data=[];
            this.bankRank.forEach((it, index) => {
              lable[this.bankRank.length-1-index] = it.logindept;
              data[this.bankRank.length-1-index] = it.sum;
            });
            let bankChart=this.$echarts.init(document.getElementById('bankChart'));

            let colorList=['#63bcfe','#63bcfe','#FFD14C','#fe9312','#FF5410'];

            let option = {
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow'
                }
              },
              legend: {show:false},
              grid: {
                top:'0%',
                left: '0%',
                right: '0%',
                bottom: '0%',
                containLabel: true
              },
              xAxis: {
                show:false
              },
              yAxis: {
                type: 'category',
                axisLine:{
                  show:false
                },
                axisTick:{
                  show:false
                },
                axisLabel:{
                  formatter:function (value, index) {
                    if(value.length>6){
                      return value.substring(0,5) + '…';
                    }else{
                      return value;
                    }
                  }
                },
                data: lable
              },
              series: [
                {
                  name: '授信金额',
                  type: 'bar',
                  label: {
                    show: true,
                    position: 'right'
                  },
                  itemStyle: {
                     normal: {
                        barBorderRadius: 50,
                        color: (params) => {
                            return colorList[params.dataIndex]
                        }
                     },
                  },
                  barWidth: 15,
                  data: data
                }
              ]
            };
            bankChart.setOption(option)
          }
        }
    };
</script>

<style scoped lang="less">
    body {
        font-family: "微软雅黑";
        margin: 0;
        padding: 0;
        background: #f5f5f5;
        width: 100%;
        height: 100%;
    }

    /deep/ #process .anticon svg {
        font-size: 50px;
    }

    #video {
        position: absolute;
        right: 0;
        bottom: 0;
        min-width: 100%;
        min-height: 100%;
        z-index: -1;
        /*background: url("../assets/img/bj.png") no-repeat left top;*/
    }

    .topcss0 {
        font-size: 16px;
        padding-left: 35px;
        background: url("../assets/img/top1.png") no-repeat left top;
    }

    .topcss1 {
        font-size: 16px;
        padding-left: 35px;
        background: url("../assets/img/top2.png") no-repeat left top;
    }

    .topcss2 {
        font-size: 16px;
        padding-left: 35px;
        background: url("../assets/img/top3.png") no-repeat left top;
    }

    .dd1 {
        width: 100%;
        min-width: 1250px;
        height: calc(100vh - 98px);
        min-height: 740px;
        position: relative;
        z-index: 1;
        background-size: 100% 100%;
    }

    .logo {
        color: #fff;
        font-size: 40px;
        font-weight: 600;
        letter-spacing: 3px;

        span{
            display: inline-block;
            width: 45px;
            height: 51px;
            /*background: url("../assets/img/logo.svg") no-repeat center;*/
            background-size: 100% 100%;
            float: left;
            margin: 10px 10px 0 0;
        }
    }

    .dd1_12 {
        font-size: 16px;
        height: 100px;
        width: 1200px;
        margin: 0 auto;
    }

    .dd1_12_1 {
        font-size: 14px;
        width: 800px;
        float: left;
        padding-top: 30px;
    }

    .dd1_12_2 {
        font-size: 14px;
        width: 388px;
        float: right;
        color: #fff;
        padding-top: 30px;
    }

    .dd1_12_3 {
        width: 100%;
        min-width: 1300px;
        max-width: 1720px;
        margin: 0 auto;
        margin-top: 35px;
    }

    .dd1_nemu1 {
        font-family: "微软雅黑";
        font-size: 20px;
        text-decoration: none;
        line-height: 54px;
        height: 54px;
        color: #fff;
        border-bottom: 2px #fff solid;
    }

    .dd1_nemu2 {
        font-family: "微软雅黑";
        font-size: 20px;
        text-decoration: none;
        line-height: 54px;
        height: 54px;
        color: #fff;
    }

    .dd1_12_4 {
        font-size: 14px;
        height: 100px;
        width: 1200px;
        margin: 0 auto;
        text-align: center;
        padding-top: 140px;
    }

    .dd1_12_5 {
        font-size: 14px;
        height: 250px;
        width: 1200px;
        margin: 0 auto;
        text-align: center;
        padding-top: 50px;
    }

    .dd1_12_5_left {
        width: 620px;
        float: left;
    }

    .dd1_12_5_right {
        width: 30%;
        float: right;
    }

    .dd1_12_5_1 {
        text-align: center;
        width: 170px;
        height: 200px;
        background: rgba(255, 255, 255, 0.2);
        float: left;
        border-radius: 7px;
    }

    .dd1_12_5_2 {
        text-align: center;
        width: 170px;
        height: 200px;
        background: rgba(255, 255, 255, 0.2);
        float: left;
        border-radius: 7px;
        margin-left: 50px;
    }

    .dd1_12_5_3 {
        text-align: center;
        width: 170px;
        height: 200px;
        background: rgba(255, 255, 255, 0.2);
        float: left;
        border-radius: 7px;
        margin-top: 50px;
    }

    .dd1_12_5_4 {
        text-align: center;
        width: 170px;
        height: 200px;
        background: rgba(255, 255, 255, 0.2);
        float: left;
        border-radius: 7px;
        margin-left: 50px;
        margin-top: 50px;
    }

    .dd1_12_5_dw_1 {
        padding-top: 90px;
        background: url("../assets/img/jrjg.png") no-repeat center 25%;
    }

    .dd1_12_5_dw_2 {
        padding-top: 90px;
        background: url("../assets/img/jrcp2.png") no-repeat center 25%;
    }

    .dd1_12_5_dw_3 {
        padding-top: 90px;
        background: url("../assets/img/zcqy.png") no-repeat center 25%;
    }

    .dd1_12_5_dw_4 {
        padding-top: 80px;
        background: url("../assets/img/yxje.png") no-repeat center 25%;
    }

    .dd1_12_5_dw_5 {
        padding-top: 90px;
        background: url("../assets/img/ljsx.png") no-repeat center 25%;
    }

    .dd1_12_5_dw_6 {
        padding-top: 90px;
        background: url("../assets/img/sxje.png") no-repeat center 25%;
    }

    .dd1_12_5_dw_7 {
        padding-top: 90px;
        background: url("../assets/img/zzdj.png") no-repeat center 25%;
    }

    .dd1_12_5_dw_8 {
        padding-top: 80px;
        background: url("../assets/img/fkje.png") no-repeat center 25%;
    }

    .dd1_12_5_wz1 {
        font-family: 'DIN_Condensed_Bold';
        font-size: 34px;
        text-align: center;
        color: #fff;
        font-weight: 200;
        margin-right: 5px;
    }

    .dd1_12_5_wz2 {
        font-size: 18px;
        text-align: center;
        color: #fff;
        line-height: 50px;
    }

    .dd1_12_5_out {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 10px;
        padding: 10px;
        height: 450px;
        width: 100%;
    }

    .dd1_12_5_in {
        background: #becbe4;
        border-radius: 10px;
        text-align: center;
        padding: 10px;
        height: 100%;
        width: 100%;
    }

    .dd1_12_5_in_top {
        width: 100%;
        height: 112px;
        background: url("../assets/img/wydk.png") no-repeat;
        background-size: 100% 100%;
    }

    .dd1_12_5_wz3 {
        font-size: 14px;
        text-align: center;
        color: #fff;
    }

    .dd2 {
        width: 100%;
        background: #FFFFFF;
        padding-bottom: 30px;
        position: relative;
    }

    .dd2_123{
        width: 1200px;
        margin: 0 auto;
        text-align: center;
        padding-top: 40px;
    }
    .dd2_12 {
        width: 1200px;
        margin: 0 auto;
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
    }

    .dd2_12a {
        width: 1200px;
        margin: 0 auto;
        text-align: center;
        margin-top: 40px;
    }
    .dd2_12a a{
        display: inline-block;
        width: 130px;
        height: 48px;
        background: #FFFFFF;
        box-shadow: 0px 0px 19px 1px rgba(143, 143, 143, 0.2);
        border-radius: 24px;
        line-height: 48px;
        cursor: pointer;
        img{
            margin-left: 5px;
        }
    }

    .dd2_12_1 {
        text-align: center;
        width: 320px;
        box-shadow: 0px 0px 19px 1px rgba(143, 143, 143, 0.2);
        border-radius: 5px;
        background: url("../assets/img/hz21.png") no-repeat left top;
    }

    .dd2_12_2 {
        text-align: center;
        width: 340px;
        height: 380px;
        background: url("../assets/img/hz21.png") no-repeat left top;
        float: left;
        margin-left: 90px;
    }

    .dd2_12_1_dw1 {
        height: 60px;
        width: 270px;
        margin: 0 auto;
        padding-top: 20px;
        text-align: left;
        font-weight: bold;
    }

    .dd2_12_1_dw2 {
        height: 60px;
        width: 300px;
        margin: 0 auto;
        padding-top: 20px;
    }

    .dd2_12_1_dw3 {
        height: 60px;
        width: 270px;
        margin: 0 auto;
        padding-top: 20px;
    }

    .dd2_12_1_dw4 {
        width: 100%;
        padding: 10px 30px 20px 30px;
        margin: 0 auto;
        text-align: left;
        color: #666666;
        font-size: 14px;
        margin-top: 10px;
    }

    .grad0{
        background: linear-gradient(to bottom,rgba(42, 149, 246, 0.1), rgba(42, 149, 246, 0));
    }
    .grad1{
        background: linear-gradient(to bottom,rgba(255, 110, 13, 0.1), rgba(255, 110, 13, 0));
    }
    .grad2{
        background: linear-gradient(to bottom,rgba(4, 200, 110, 0.1), rgba(4, 200, 110, 0));
    }

    .dd2_12_1_dw5 {
        height: 20px;
        width: 270px;
        margin: 0 auto;
    }

    .dd2_12_1_dw6 {
        height: 20px;
        width: 33%;
        float: left;
    }

    .dd2_12_5_wz1 {
        font-family: 'DIN_Condensed_Bold';
        font-size: 16px;
        text-align: center;
        color: #ff6e0d;
    }

    .dd2_12_5_wz2 {
        font-family: 'DIN_Condensed_Bold';
        font-size: 16px;
        text-align: center;
        color: #333333;
    }

    .dd2_12_5_wz3 {
        font-size: 14px;
        text-align: center;
        color: #999999;
    }

    .dd3 {
        width: 100%;
        background: #EAF3FB;
        padding-bottom: 30px;
    }
    .dd6 {
      width: 100%;
      height: 300px;
      background: #FFFFFF;
      padding-bottom: 30px;
    }
    .dd3_12 {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
    }

    .dd3_6 {
        width: 1000px;
        float: right;
        margin-top: 30px;
    }

    .dd3_t {
        font-size: 14px;
        text-align: left;
        padding-top: 0px;
    }

    .dd3_t1 {
        height: 1px;
        width: 552px;
        background: #eeeeee;
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .dd3_t2 {
        font-size: 16px;
        text-align: left;
        line-height: 32px;
        padding-top: 10px;
        color: #333333;
        cursor: pointer;
    }

    .dd3_t3 {
        font-size: 14px;
        text-align: left;
        line-height: 24px;
        padding-top: 0px;
        color: #999999;
    }

    .dd3_t4 {
        font-size: 14px;
        text-align: left;
        line-height: 24px;
        height: 70px;
        padding-top: 8px;
        color: #999999;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .dd3_t5 {
        width: 100%;
        text-align: right;
        margin-top: 30px;
    }
    .dd3_t5 a{
        display: inline-block;
        width: 130px;
        height: 48px;
        background: #FFFFFF;
        box-shadow: 0px 0px 19px 1px rgba(143, 143, 143, 0.2);
        border-radius: 24px;
        line-height: 48px;
        text-align: center;
        cursor: pointer;
        img{
            margin-left: 5px;
        }
    }

    .dd4 {
        width: 100%;
        background: #fafafa;
    }

    .dd4_t {
        font-size: 14px;
        text-align: center;
        padding-top: 40px;
        width: 1200px;
        margin: 0 auto;
    }

    .dd4_t2 {
        font-size: 14px;
        padding-top: 20px;
        width: 240px;
        float: left;
    }

    .dd4_t2 img {

        width: 150px;
        height: 30px;
    }

    .dd5 {
        width: 100%;
        background: #383d41;
        margin: 0 auto;
        padding-bottom: 20px;
    }

    .dd5_copyright {
        color: #fff;
        font-size: 14px;
        line-height: 25px;
        text-align: center;
        padding-top: 18px;
    }

    .cs1 {
        width: 100%;
        height: 90px;
        background: #fff;
    }

    .cs1_12 {
        font-size: 14px;
        height: 100px;
        width: 1200px;
        margin: 0 auto;
    }

    .cs1_12_1 {
        font-size: 14px;
        width: 288px;
        float: left;
        padding-top: 30px;
    }

    .cs1_12_2 {
        color: #ffffff;
        font-size: 16px;
        padding-top: 10px;
        position: relative;
        display: flex;
        justify-content: space-around;
        float: right;

        .menu_sub{
            position: absolute;
            top: 50px;
            left: -50px;
            background: #ffffff;
            box-shadow: 0 6px 24px 4px rgba(143, 143, 143, 0.2);
            padding: 20px;
            line-height: 32px;
            border-radius: 4px;

            a{
                color: #333333;
                font-size: 15px;
            }

            i.uparrow {
                position: absolute;
                top: -20px;
                left: 44px;
                height: 22px;
                line-height: 22px;
                padding-right: 44px;
                font-size: 22px;
                background: url("../assets/img/uparrow.png") no-repeat;
            }
        }
    }

    .cs1_12_2 a {
        color: white;
        font-size: medium;
        font-family: "微软雅黑";
    }

    .cs1_12_3 {
        color: #ffffff;
        font-size: 16px;
        padding-top: 10px;
        position: absolute;
        display: flex;
        justify-content: space-around;
      right: 0px;
    }

    .cs1_12_3 a {
        color: white;
        font-size: medium;
        font-family: "微软雅黑";
    }

    .cs2 {
        width: 100%;
        height: 64px;
        background: #0291ef;
    }

    .cs2_nemu1 {
        font-family: "微软雅黑";
        font-size: 18px;
        text-decoration: none;
        line-height: 44px;
        height: 44px;
        color: #fff;
        border-bottom: 2px #fff solid;
        padding-bottom: 10px;
        cursor: pointer;
    }

    .cs2_nemu2 {
        font-family: "微软雅黑";
        font-size: 18px;
        text-decoration: none;
        line-height: 44px;
        height: 44px;
        color: #fff;
        cursor: pointer;
        margin-left: 30px
    }

    .cs3 {
        width: 100%;
        background: #f5f5f5;
    }

    .cs3_12 {
        font-size: 14px;
        width: 1200px;
        margin: 0 auto;
        text-align: left;
    }

    .cs3_12_1 {
        font-family: "微软雅黑";
        font-size: 14px;
        line-height: 56px;
        color: #999;
    }

    .cs3_12_2 {
        font-family: "微软雅黑";
        font-size: 14px;
        line-height: 56px;
        color: #666;
    }

    .cs3_12_w {
        font-size: 14px;
        height: 473px;
        width: 1200px;
        margin: 0 auto;
        background: #fff;
        text-align: left;
    }

    .cs3_12_w2 {
        font-size: 14px;
        height: 413px;
        width: 1140px;
        margin: 0 auto;
        background: #fff;
        text-align: left;
    }

    .cs3_12_w3 {
        font-size: 14px;
        width: 1200px;
        margin: 0 auto;
        background: #fff;
        text-align: left;
        min-height: 450px;
    }

    .cs3_12_w4 {
        height: 1px;
        width: 1120px;
        background: #eeeeee;
        margin-top: 5px;
        margin-bottom: 15px;
        margin: 0 auto;
    }

    .cs3_12_w5 {
        font-family: "微软雅黑";
        font-size: 14px;
        line-height: 28px;
        color: #333;
        text-align: left;
        width: 1120px;
        margin: 0px auto;
        background: #fff;
        margin-top: 30px;
    }

    .cs3_12_w6 {
        font-family: "微软雅黑";
        font-size: 20px;
        line-height: 28px;
        color: #333;
        text-align: center;
        width: 1120px;
        margin: 0 auto;
        background: #fff;
        padding-top: 20px;
    }

    .cs3_12a {
        font-size: 14px;
        width: 1200px;
        margin: 20px auto;
        text-align: center;
        color: #999999;
    }

    .cs3_12_w7 {
        font-family: "微软雅黑";
        font-size: 14px;
        line-height: 28px;
        color: #333;
        float: left;
        margin: 0 auto;
    }

    .cs4 {
        width: 100%;
        background: #f5f5f5;
        height: 3275px;;
    }

    .cs4a {
        width: 100%;
        background: #f5f5f5;
        height: 1506px;;
    }

    .cs4_12 {
        font-size: 14px;
        width: 1200px;
        margin: 0 auto;
        text-align: left;
    }

    .cs4_12_1 {
        font-family: "微软雅黑";
        font-size: 14px;
        line-height: 56px;
        color: #999;
    }

    .cs4_12_2 {
        font-family: "微软雅黑";
        font-size: 14px;
        line-height: 56px;
        color: #666;
    }

    .cs4_12_3 {
        font-family: "微软雅黑";
        font-size: 14px;
        line-height: 56px;
        color: #0291ef;
    }

    .cs4_12_w {
        font-size: 14px;
        width: 1200px;
        margin: 0 auto;
        text-align: center;
    }

    .cs4_12_w2 {
        font-size: 14px;
        width: 1140px;
        margin: 0 auto;
        background: #fff;
        text-align: left;
    }

    .cs4_12_w3 {
        font-size: 14px;
        width: 1200px;
        margin: 0 auto;
        background: #fff;
        text-align: left;
        min-height: 450px;
    }

    .cs4_12_w4 {
        font-size: 14px;
        width: 1158px;
        margin: 0 auto;
        background: #fff;
        text-align: center;
    }

    .cs4_12_5_wz0 {
        font-size: 20px;
        text-align: center;
        color: #333;
        line-height: 32px;
    }

    .cs4_12_5_wz1 {
        font-size: 18px;
        text-align: center;
        color: #0291ef;
        line-height: 32px;
    }

    .cs4_12_5_wz2 {
        font-size: 18px;
        text-align: center;
        color: #ff6e0d;
        line-height: 32px;
    }

    .cs4_12_5_wz2a {
        font-size: 18px;
        text-align: center;
        color: #333;
        line-height: 90px;
    }

    .cs4_12_5_wz3 {
        font-size: 14px;
        text-align: center;
        color: #333;
        line-height: 32px;
    }

    .cs4_12_5_wz4 {
        font-size: 14px;
        text-align: center;
        color: #999;
        line-height: 32px;
    }

    .cs4_12_cp1 {
        font-size: 14px;
        height: 140px;
        width: 225px;
        background: #fff;
        text-align: center;
        float: left;
        line-height: 130px;
        padding-top: 20px;
        border-bottom: 1px solid #eeeeee;
    }

    .cs4_12_cp2 {
        font-size: 14px;
        height: 130px;
        width: 290px;
        background: #fff;
        padding-top: 30px;
        border-bottom: 1px solid #eeeeee;
        text-align: left;
        float: left;
    }

    .cs4_12_cp3 {
        font-size: 14px;
        height: 130px;
        width: 243px;
        background: #fff;
        padding-top: 30px;
        border-bottom: 1px solid #eeeeee;
        text-align: left;
        float: left;
    }

    .cs4_12_cp4 {
        font-size: 14px;
        height: 130px;
        width: 235px;
        background: #fff;
        padding-top: 30px;
        border-bottom: 1px solid #eeeeee;
        text-align: left;
        float: left;
    }

    .cs4_12_cp5 {
        font-size: 14px;
        height: 130px;
        width: 207px;
        background: #fff;
        padding-top: 30px;
        border-bottom: 1px solid #eeeeee;
        text-align: left;
        float: left;
    }

    .cs4_12_cp6 {
        font-size: 14px;
        height: 130px;
        width: 110px;
        background: #fff;
        text-align: left;
        float: left;
        line-height: 130px;
        padding-top: 20px;
        border-bottom: 1px solid #eeeeee;
    }

    .cs4_cp7 {
        height: 2px;
        width: 1158px;
        background: #999;
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .cs4_12_jg1 {
        font-size: 14px;
        height: 140px;
        width: 225px;
        background: #fff;
        text-align: center;
        float: left;
        line-height: 130px;
        padding-top: 20px;
        border-bottom: 1px solid #eeeeee;
    }

    .cs4_12_jg2 {
        font-size: 14px;
        height: 130px;
        width: 690px;
        background: #fff;
        padding-top: 30px;
        text-align: center;
        float: left;
        border-bottom: 1px solid #eeeeee;
    }

    .cs4_12_jg3 {
        font-size: 14px;
        height: 130px;
        width: 285px;
        background: #fff;
        padding-top: 30px;
        text-align: left;
        float: left;
        border-bottom: 1px solid #eeeeee;
    }

    .dt1 {
        width: 100%;
        background: #f5f5f5;
    }

    .dt2 {
        width: 100%;
        background: #f5f5f5;
    }

    .dt_12_w {
        font-size: 14px;
        width: 1200px;
        margin: 0 auto;
        text-align: left;
        min-height: 90px;
        background: #fff;
    }

    .dt_12_w2 {
        font-size: 14px;
        width: 1200px;
        margin: 0 auto;
        text-align: left;
        height: 140px;
        background: #fff;
    }

    .dt_12_w3 {
        font-size: 14px;
        width: 1200px;
        margin: 0 auto;
        text-align: left;
        height: 500px;
        background: #fff;
    }

    .dt_1120_w {
        font-size: 14px;
        width: 1120px;
        margin: 0 auto;
        text-align: left;
    }

    .dt_12_lb1 {
        font-size: 14px;
        height: 43px;
        width: 100px;
        background: #fff;
        text-align: center;
        float: left;
        cursor: pointer;
    }

    .dt_12_lb2 {
        font-size: 14px;
        height: 43px;
        width: 105px;
        background: #fff;
        text-align: center;
        float: left;
        cursor: pointer;
    }

    .dt_12_lb3 {
        font-size: 14px;
        height: 43px;
        width: 895px;
        background: #fff;
        text-align: center;
        float: left;
    }

    .dt_12_5_wz2a {
        font-size: 20px;
        text-align: left;
        color: #333;
        line-height: 60px;
        cursor: pointer;
    }

    .dt_12a {
        font-size: 14px;
        width: 1200px;
        margin: 0px auto;
        text-align: left;
        color: #999999;
        line-height: 40px;
        cursor: pointer;
    }

    .dt_12b {
        height: 1px;
        width: 1120px;
        background: #eee;
        margin-top: 25px;
        margin-bottom: 5px;
    }

    .dt_12c {
        font-size: 14px;
        text-align: left;
        line-height: 24px;
        padding-top: 8px;
        color: #666666;
        cursor: pointer;
    }

    .dt_12d {
        height: 1px;
        width: 1200px;
        background: #eee;
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .clearfloat {
        clear: both;
        height: 0;
        font-size: 1px;
        line-height: 0px;
    }

    .ss_bg {
        width: 540px;
        height: 52px;
        background: url("../assets/img/hz65.png") no-repeat left top;
        margin-left: 28px;
    }

    .ss_input {
        height: 14px;
        border-top-width: 0px;
        border-right-width: 0px;
        border-bottom-width: 0px;
        border-left-width: 0px;
        border-top-style: solid;
        border-right-style: solid;
        border-bottom-style: solid;
        border-left-style: solid;
        border-top-color: #555555;
        border-right-color: #555555;
        border-bottom-color: #e9e9e9;
        border-left-color: #555555;
        background-color: #fff;
        width: 410px;
        height: 48px;
        margin-left: 50px;
        margin-top: 3px;
    }

    .ss_1 {
        float: left;
    }

    .ss_2 {
        float: right;
    }

    .tab-box input {
        display: none;
    }

    .tab-box label {
        display: inline-block;
        text-align: center;
        width: 120px;
        height: 30px;
        background-color: #FFF;
        color: #333;
        font-size: 14px;
        line-height: 30px;
        cursor: pointer;
        float: left;
    }

    .tab-box input:nth-of-type(1):checked ~ .tab-contents .tab-content:nth-of-type(1),
    .tab-box input:nth-of-type(2):checked ~ .tab-contents .tab-content:nth-of-type(2),
    .tab-box input:nth-of-type(3):checked ~ .tab-contents .tab-content:nth-of-type(3),
    .tab-box input:nth-of-type(4):checked ~ .tab-contents .tab-content:nth-of-type(4),
    .tab-box input:nth-of-type(5):checked ~ .tab-contents .tab-content:nth-of-type(5),
    .tab-box input:nth-of-type(6):checked ~ .tab-contents .tab-content:nth-of-type(6) {
        display: block;
    }

    .tab-box input:nth-of-type(1):checked ~ .tab-box-label label:nth-of-type(1),
    .tab-box input:nth-of-type(2):checked ~ .tab-box-label label:nth-of-type(2),
    .tab-box input:nth-of-type(3):checked ~ .tab-box-label label:nth-of-type(3),
    .tab-box input:nth-of-type(4):checked ~ .tab-box-label label:nth-of-type(4),
    .tab-box input:nth-of-type(5):checked ~ .tab-box-label label:nth-of-type(5),
    .tab-box input:nth-of-type(6):checked ~ .tab-box-label label:nth-of-type(6) {
        color: #0291ef;
        background-color: #d9effd;
        border-radius: 4px
    }

    .silder-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        margin: auto;
        width: 100%;
        transition: 1s;
    }

    #silderBox {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 90px;
        margin: auto;
    }

    .table-list {
        width: 90%;
        height: 100%;
        margin: auto;
        font-size: 14px;
    }

    .project-case {
        padding-bottom: 3rem;
        overflow: hidden;
        width: 1200px;
        margin: 20px auto;
        display: none;

        .title {
            font-size: 3.6rem;
            padding: 5rem 0;

            span {
                cursor: pointer;
            }
        }

        .content {
            .content-list {
                user-select: none;
                display: flex;
                flex-wrap: nowrap;
                width: 100%;

                .content-item {
                    height: 80px;
                    align-items: center;

                    img {
                        transition: all 0.5s;
                        width: 100%;
                        position: absolute;
                        top: 50%;
                        padding-right: 5rem;
                        transform: translateY(-50%);
                    }
                }
            }
        }
    }

    .qrCode {
        display: inline-block;
        width: 180px;
        position: fixed;
        right: 0px;
        top: 50%;
        z-index: 99;
    }

    .qrCode img {
        width: 150px;
    }

    .iconCancel {
        display: flex;
        justify-content: flex-end;
        align-content: flex-end;
    }

    /deep/ .ant-steps-item-icon {
        margin-left: 34px;
    }
</style>

<style scoped lang="less">
    .container{
        width: 100%;
        min-width: 1250px;
        height: calc(100vh - 98px);
        min-height: 740px;
        position: relative;
        z-index: 10;
        background-size: 100% 100%;
    }
    .navListBox{
        width: 100%;
        min-width: 1300px;
        max-width: 1720px;
        margin: 0 auto;
        padding-top: 10px;
      position: relative;
    }
    .logoBox{
        float: left;
        .name{
            color: #ffffff;
            /*font-family: 'loginTip';*/
            font-size: 24px;
        }
    }
    .menuBox{
        float: left;
        margin-left: 80px;
        margin-top: 23px;
    }
    .slogan{
        width: 1200px;
        color: #ffffff;
        font-family: 'sign';
        font-size: 80px;
        letter-spacing: 2px;
        text-align: center;
        text-shadow: 0px 0px 10px rgba(12, 93, 184, 0.63);
        margin: 0 auto;
        margin-top: 130px;
    }
    .navList{
        width: 100%;
        min-width: 1300px;
        max-width: 1720px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        margin-top: 200px;
    }
    .navBox{
        width: 240px;
        height: 70px;
        background: linear-gradient(174deg,#0084ff,#0042ff);
        border-radius: 16px;

        a{
            display: block;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
        }

        .navIco{
            width: 13%;
            margin-right: 10px;
            vertical-align: middle;
        }

        .navTitle{
            color: #ffffff;
            font-size: 26px;
            line-height: 70px;
        }
    }
    .totalListBox{
        width: 100%;
        margin-top: 120px;
    }
    .totalList{
        width: 100%;
        height: 100%;
        min-width: 1300px;
        max-width: 1720px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
    }
    .totalbox{
        width: 160px;
        height: 185px;
        background: rgba(0,0,0,0.4);
        border-radius: 10px;
        box-shadow: 0px 0px 10px 1px rgba(255, 255, 255, 0.3);
        text-align: center;
        padding-top: 30px;

        a{
            display: block;
            width: 100%;
            height: 100%;
        }
    }

    @media screen and (max-width: 1850px) {
        .navListBox {
            padding: 20px 40px 0 40px;
        }
        .dd1_12_3{
            padding: 0 40px;
        }
        .navList{
            padding: 0 40px;
        }
        .totalList{
            padding: 0 40px;
        }
    }

    .loanBox{
        width: 100%;
        background-color: #EAF3FB;
    }
    .loanMain{
        width: 1200px;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        div{
            line-height: 98px;
        }

        .loanTitle{
            font-size: 20px;
            font-weight: 600;
            img{
                margin-right: 10px;
            }
        }

        .loanList{
            p{
                font-size: 16px;
                display: inline-block;
            }
        }
    }

    .processBox{
        width: 100%;
        height: 242px;
        background: url('../assets/img/lcbj.png') no-repeat;
        background-size: 100% 100%;

        /deep/ .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after{
            background-color: #ffffff;
        }

        /deep/.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title{
            color: #ffffff;
        }
    }

    .newsSelect{
        width: 132px;
        float: left;
        margin-top: 30px;
        text-align: center;

        p{
            width: 100%;
            height: 45px;
            font-size: 18px;
            font-weight: 600;
            line-height: 45px;
            margin-bottom: 20px !important;
            cursor: pointer;
        }

        .active{
            color: #1492ff;
            background-color: #ffffff;
            border: solid 1px #1492ff;
        }
    }
    .newslistBox{
        width: 100%;
        background-color: #ffffff;
        box-shadow: 0px 0px 19px 1px rgba(143, 143, 143, 0.2);
        padding: 10px 40px;
        margin-bottom: 20px;
    }

    .albj{
        width: 100%;
        position: absolute;
        z-index: 3;
        top: 0;
    }
    .case{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        position: relative;
        z-index: 5;
    }
    .caseBox{
        width: 60%;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .listBox{
      width: 50%;
      margin-top: 30px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .caseTitle{
        width: 100%;
        font-size: 24px;
        font-weight: 600;

        .caseIco{
            display: inline-block;
            width: 5px;
            height: 20px;
            background-color: #2372F3;
            border-radius: 5px;
            float: left;
            margin: 8px 10px 0 0;
        }

        .caseMore{
            font-size: 14px;
            line-height: 36px;
            float: right;
        }
    }
    .alList{
        width: 48%;
        border: solid 1px #eeeeee;
        margin-top: 20px;
        position: relative;

        .body{
            padding: 15px 20px 50px 20px;
            h2{
                color: #424242;
                font-size: 16px;
                font-weight: 600;
            }
            .alMes{
                margin: 15px 0 !important;

                span:nth-child(1){
                    display: inline-block;
                    min-width: 100px;
                    padding: 6px 12px;
                    background: #eeeeee;
                    border-radius: 5px;
                    color: #666;
                    font-size: 14px;
                    font-weight: 600;
                    margin-right: 12px;
                }

                .alNum{
                    color: #f44336;
                    font-weight: 600;
                }
            }
        }

        .aljg{
            width: 100%;
            text-align: center;
            color: #ffffff;
            line-height: 38px;
            position: absolute;
            bottom: 0;
        }
        .cg1{
            background-color: #feb177;
        }
        .cg2{
            background-color: #85a8ea;
        }
        .cg3{
            background-color: #61cf93;
        }
        .cg4{
            background-color: #bb9ad8;
        }
    }

    .needsBox{
        width: 35%;
        margin-top: 30px;
    }
    .needsList{
        width: 100%;
        margin-top: 30px;
        ul{
            width: 100%;
            height: 65px;
            background: #EAF3FB;
            margin-bottom: 30px;
        }
        .needsTime{
            width: 65px;
            height: 100%;
            background-color: #0e4fa1;
            float: left;
            color: #ffffff;
            text-align: center;

            span:nth-child(1){
                display: block;
                font-size: 20px;
                margin-top: 5px;
            }
        }
        .needsMes{
            width: 84%;
            padding: 0 10px;
            float: left;
            color: #0e4fa1;
            font-size: 16px;
            line-height: 65px;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
        }
    }
    #silderBox {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 475px;
        margin: auto;
    }
    .silder-wrapper {
        position: absolute;
        top: 0;
        left: 0;
        margin: auto;
        width: 100%;
        transition: 1s;
    }

    .linkBox{
        width: 1200px;
        margin: 0 auto;
        margin-top: 30px;
    }
    .linkBt{
        width: 100%;
        font-size: 20px;
        font-weight: 600;

        .caseIco{
            display: inline-block;
            width: 5px;
            height: 20px;
            background-color: #2372F3;
            border-radius: 5px;
            float: left;
            margin: 5px 10px 0 0;
        }
    }
    .linkList{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 20px;
    }
    .linkNr{
        width: 204px;
        height: 84px;
        line-height: 79px;
        background: #ffffff;
        text-align: center;
        border: 1px solid #f2f2f2;
        box-shadow: 0px 0px 10px 1px rgba(12, 93, 184, 0.1);
        border-radius: 4px;
        margin: 10px 35px 10px 0;

        a{
            display: block;
        }
    }

    .unit{
        color: #999999;
        line-height: 30px;
        margin-bottom: 10px;
    }

    /* 滚动头部效果 */
    .topActive{
        .container{
            height: calc(100vh - 348px);
            min-height: 490px;
        }

        .topMain{
            width: 100%;
            background-color: #ffffff;
            padding-bottom: 20px;
            box-shadow: 0px 0px 19px 1px rgba(143, 143, 143, 0.3);
            position: fixed;
            top: 0;
            z-index: 999;
        }

        .logo{
            color: #333333;
            span{
                width: 45px;
                height: 51px;
                background: url("../assets/img/logo2.svg") no-repeat center;
                background-size: 100% 100%;
            }
        }

        .name{
            color: #005BAA;
        }

        .cs2_nemu1{
            color: #333333;
            border-bottom: 2px #005BAA solid;
        }
        .cs2_nemu2{
            color: #333333;
        }

        .cs1_12_2{
            color: #333333;
            a{
                color: #333333;
            }
        }

        .cs1_12_3{
            color: #333333;
            a{
                color: #333333;
            }
        }
    }
</style>
